import * as React from "react";
import {ReportService} from "../../service/v1/report";
import Wait from "../wait";
import {LocalitiesService} from "../../service/v1/localities";
import ProjectScreen from "../v1/project/project_screen";


export default class DownloadPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            localities: [],
            locality_id: 0,
        }
        this.getProjectLocalities = this.getProjectLocalities.bind(this)
    }


    componentDidMount() {
        this.getProjectLocalities()
    }

    handleChanges = (e) => {
        console.log(e.target.name)
        this.setState({[e.target.name]: e.target.value})
    }

    render() {
        return (<div className={'row'}>
            <div className={'col col-sm-1'}/>

            <div className={'col col-sm-10'}
                 style={{border: '1px solid #ccc', boxShadow: '0 0 40px #ccc', marginTop: '20px'}}>
                <div style={{padding: '20px'}}>
                   {/* <button className={'btn-list'} title={'Configure Chapters'} style={{float: 'left', margin: '10px'}}
                    >Configure Chapters
                    </button>*/}
                    <div style={{overflow: 'hidden', display: 'inherit', float: 'left', margin: '0px'}}>
                        <select name={'locality'} style={{margin: '5px 16px 10px 10px', float: 'right', padding: '6px'}}
                                onChange={this.handleChanges}>
                            <option value={undefined}>- Choose Village -</option>
                            {this.state.localities.map((d, i) => {
                                return (<option value={d.id} key={i}>{d.name}</option>)
                            })}
                        </select>
                    </div>
                    <button className={'btn-list'} title={'Download Report'} style={{float: 'right', margin: '10px'}}
                            onClick={() => this.downloadReport(this.props.project.id)}>
                        <span className={'fa-solid fa-file-word fa-xl'}/>
                    </button>

                </div>
            </div>
        </div>)

    }

    downloadReport(project) {

        let locality_id = parseInt(this.state.locality)
        if (locality_id === undefined) {
            return
        }
        ReportService.createFinalReport(project, locality_id).then(r => {
                try {
                    Wait.dismiss()
                    let result = r.data
                    if (result.message.includes("succes")) {
                        ReportService.downloadFinalReport(project, locality_id).then(
                            response => this.loadImage(response.data, project)
                        )
                    }
                } catch (e) {
                    Wait.dismiss()
                    console.log(e)
                }
            }
        )
    }

    getProjectLocalities() {
        LocalitiesService.fetchLocalityByProject(this.props.project.id).then(r => {
                try {
                    this.setState({
                        localities: r.data.results,
                    })
                } catch (e) {
                    console.log(e)
                }
            }
        )
    }

    loadImage(data, project) {
        // we can all pass them to the Blob constructor directly
        const new_blob = new Blob([data], {type: ''});
        // with blob: URI, the browser will try to load 'data' as-is
        const url = URL.createObjectURL(new_blob);
        //window.open(url);
        let a = document.createElement('a');
        a.href = url;
        a.download = this.props.project.name.replace(/\s/g, "_") + '.docx';
        a.click();
    }

}
